<template>
  <!-- eslint-disable vue/no-template-shadow -->
  <div class="member">
    <button class="btn btn-loadmore btn-block">
      <a href="" class="login" @click.prevent="onLogin"> Login with </a>
      <SvgImg id="logo-header-small-soco" name="logo-header-small-soco" width="44" height="10" />
    </button>

    <ul v-for="(item, index) in items" :key="index" class="menu">
      <MenuMemberList v-for="(item, index) in item" :key="index" :item="item" />
    </ul>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import MenuMemberList from './MenuMemberList';
import Auth from '@/shared/auth';
export default {
  name: 'menu-guest',
  components: { MenuMemberList },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    ...mapMutations(['closeOffCanvas', 'modalAuth']),
    onLogin() {
      Auth.CentralAuth.login();
    },
  },
};
</script>
